import { buildKey } from '@/common/utils';

function getColumns(columns, callback = null) {
  return callback ? callback(columns) : [...columns];
}

const pageSizeOptions = [
  {
    value: '10',
    label: '10',
  },
  {
    value: '15',
    label: '15',
  },
  {
    value: '20',
    label: '20',
  },
];

const statusFilterOptions = [
  { value: null, label: 'All' },
  { value: 1, label: 'Open' },
  { value: 2, label: 'Resolved' },
];

const statusTicketResponseOptions = statusFilterOptions;

function buildRowData(rows = [], rowKey = 'id', keyName = null) {
  const _buildItemData = (el) => ({
    ...el,
    key: el.key ? el.key : buildKey(keyName, el[rowKey]),
    index: el.index ? el.index : buildKey(keyName, el[rowKey]),
  });
  return rows.map((el) => _buildItemData(el));
}

export {
  getColumns,
  pageSizeOptions,
  buildRowData,
  statusFilterOptions,
  statusTicketResponseOptions,
};
